<template>
	<div class="article-card flex-col-ac-jc" ref="articleCard" :style="cardStyle" @click="toDetail">
		<div class="card-image">
			<img referrerPolicy="no-referrer" :src="article.articleCover" :alt="article.articleTitle"
				class="cover-image" />
			<div class="image-overlay flex-row-ac-js">
				<div class="view-count flex-row-ac-jc">
					<img class="view-icon" src="@/assets/view.png" />
					<span class="count-num">{{ article.browseNum }}</span>
				</div>
				<div class="like-count flex-row-ac-jc">
					<img class="like-icon" src="@/assets/collect.png" />
					<span class="count-num">{{ article.upvoteNum }}</span>
				</div>
			</div>
		</div>
		<div class="card-content flex-col-as-jb">
			<h3 class="card-title">{{ article.articleTitle }}</h3>
			<div class="content-bottom flex-row-ac-jb">
				<p class="card-author">{{ article.articleAuthor }}</p>
				<img class="like-button" :src="require(`@/assets/collect-o${article.ifUpvote?'n':'ff'}.png`)"
						@click.stop="toCollect" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ArticleCard',
		props: {
			article: {
				type: Object,
				required: true
			},
			aspectRatio: {
				type: Number,
				description: '宽高比，默认为553/625≈0.885'
			}
		},
		data() {
			return {
				currentWidth: 0
			}
		},
		computed: {
			// 默认宽高比为553/625
			cardStyle() {
				return {
					height: `${this.currentWidth / (this.aspectRatio || 0.885)}px`
				}
			}
		},
		mounted() {
			// 初始计算宽度
			this.updateWidth();
			// 监听窗口大小变化
			window.addEventListener('resize', this.updateWidth);
		},
		beforeUnmount() {
			// 移除事件监听
			window.removeEventListener('resize', this.updateWidth);
		},
		methods: {
			toCollect() {
				this.$emit('collectArticle', this.article);
			},
			toDetail() {
				this.$router.push({
					path: '/gallery/detail',
					query: {
						articleId: this.article.articleId
					}
				});
			},
			updateWidth() {
				// 获取组件自身的宽度
				this.currentWidth = this.$el.clientWidth;
			}
		}
	}
</script>

<style scoped lang="scss">
	.article-card {
		background-color: #fff;
		width: 100%;
		border-radius: 20px;
		overflow: hidden;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
		cursor: pointer;
		display: flex;
		flex-direction: column;
	}

	.article-card:hover {
		transform: translateY(-4px);
	}

	.card-content {
		width: 100%;
		height: 150px;
		padding: 20px 25px;

		.card-title {
			height: 70px;
			font-size: 18px;
			line-height: 30px;
			font-weight: 600;
			color: #333;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.content-bottom {
			width: inherit;

			.card-author {
				font-size: 14px;
				color: #666;
				flex: 1;
			}

			.like-button {
				width: 29px;
				height: 27px;
			}
		}

	}

	.card-image {
		position: relative;
		flex: 1;
		overflow: hidden;

		.cover-image {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform 0.5s ease;
		}

		.article-card:hover .cover-image {
			transform: scale(1.05);
		}

		.image-overlay {
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			padding: 15px 25px;
			background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
			color: white;
			font-size: 12px;

			.view-count {
				margin-right: 12px;
			}

			.view-count,
			.like-count {
				padding: 0 12px;
				height: 30px;
				background-color: rgba(255, 255, 255, 0.6);
				border-radius: 18px;

				.view-icon {
					width: 18px;
					height: 12px;
				}

				.like-icon {
					width: 13px;
					height: 12px;
				}

				.count-num {
					font-weight: 500;
					font-size: 13px;
					color: #FFFFFF;
					margin-left: 8px;
				}
			}
		}
	}
</style>